// Can't polyfill if we can't extend... ¯\_(ツ)_/¯
/* eslint-disable no-extend-native */
/**
 * We use modern bundles in any browser that has implemented the `nomodule`
 * attribute on the HTML Script element. Browser support for this element is
 * as follows: (https://caniuse.com/mdn-html_elements_script_nomodule)
 *    Chrome 61
 *    Edge 16
 *    Firefox 60
 *    Opera 48
 *    Safari 11
 *    Samsung 8.2
 *
 * Any feature we need that is not available in those browsers should be
 * polyfilled.
 */
// PUBLIC_URL is defined in Webpack scope, uses getPublicUrl for build contexts
// eslint-disable-next-line no-undef, max-len
__webpack_public_path__ =
  window.__webpack_public_path__ || process.env.PUBLIC_URL;

// eslint-disable-next-line no-undef, max-len
__webpack_nonce__ = window?.__INITIAL_DATA__?.nonce;

if (typeof Promise.prototype.finally !== 'function') {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise/finally#description
  Object.defineProperty(Promise.prototype, 'finally', {
    configurable: true,
    enumerable: false,
    value: function finallyPolyfill(fn) {
      return this.then(
        result => Promise.resolve(fn()).then(() => result),
        reason => Promise.resolve(fn()).then(() => Promise.reject(reason)),
      );
    },
    writable: true,
  });
}
